export const CURRENCY = "$";
export var recordsLimit = 10;
export var recordsLimit50 = 50;
export const googleMapApiKey = "";

export const ROLE = {
  SUPER_ADMIN: "super-admin",
  STAFF_ADMIN: "staff-admin",
  PROFESSIONAL_GOPHER: "professional-gopher",
  GOPHER: "gopher",
  CUSTOMER: "customer",
};
export const ROLE_LABEL = {
  [ROLE.SUPER_ADMIN]: "Super Admin",
  [ROLE.STAFF_ADMIN]: "Staff Admin",
  [ROLE.PROFESSIONAL_GOPHER]: "Professional",
  [ROLE.GOPHER]: "Gopher",
  [ROLE.CUSTOMER]: "Customer",
};
export const USER_ACTIVE_STATUS = {
  INCOMPLETE_PROFILE: "incomplete-profile",
  PENDING_VERIFICATION: "pending-verification",
  ACTIVE: "active",
  USER_DEACTIVATED: "user-deactivated",
  SYSTEM_DEACTIVATED: "system-deactivated",
  REJECTED_VERIFICATION: "rejected-verification",
};

export const USER_STATUS = {
  ALL: "all",
  ACTIVE: true,
  INACTIVE: false,
};
export const USER_STATUS_OPTIONS = [
  { label: "All", value: USER_STATUS.ALL },
  { label: "Active", value: USER_STATUS.ACTIVE },
  { label: "Inactive", value: USER_STATUS.INACTIVE },
];
export const OTP_TYPE = {
  LOGIN: "login",
  FORGET_PASSWORD: "forget-password",
  VERIFY_EMAIL: "verify-email",
};

export const PLATFORM = {
  LOCAL: "local",
  GOOGLE: "google",
  APPLE: "apple",
};

export const WEIGHT_LIMIT = {
  FIVE_KILOS: "5kg",
  TEN_KILOS: "10kg",
  FIFTEEN_KILOS: "15kg",
};
